<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
        <v-card-title>
            <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-icon class="mr-1" color="green">mdi-calendar-account</v-icon>
            {{ title }}
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>

        <!-- table list -->
        <!-- @click:row="goToProgramList"  -->
        <v-data-table :headers="headers" @click:row="goToProgramList" :items="userList" :search="search" sort-by="firstname" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" class="table-striped elevation-1" :loading="loading">
            <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar v-if="item.avatar" size="32" class="mr-2">
                    <img :src="item.avatar" />
                </v-avatar>
                <v-avatar v-else color="info" size="32" class="mr-2">
                    <v-icon dark> mdi-account-circle </v-icon>
                </v-avatar>
            </template>
        </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import formatData from "../utils/formatData";
import getUserCoachList from "../data/getUserCoachList";
import getOrgInfoById from "../data/getOrgInfoById";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
import getProgramNumberByUserId from "../data/getProgramNumberByUserId";
import {
    mapGetters
} from "vuex";
import getOrgList from "../data/getOrgList";
export default {
    name: 'OrganizationCoachList',
    metaInfo: {
        title: 'Orgrnization Coach List'
    },
    data() {
        return {
            title: "",
            search: "",
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "Name",
                    value: "name",
                },
                {
                    text: "Phone Nmber",
                    value: "phoneNumber",
                },
                {
                    text: "Program",
                    value: "programNumber"
                },
                {
                    text: "หน่วยงาน",
                    value: "orgName",
                },
                {
                    text: "Role",
                    value: "roleText",
                }
            ],
            userList: [],
            roleList: [{
                    challengeAdmin: "Admin"
                },
                {
                    superAdmin: "Super Admin"
                }
            ],
            loading: true
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Organization";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });

        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessOrgAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isAccessOrgAdmin) {
                (async () => {
                    this.loading = true;
                    if( this.id == undefined ){
                        const userInfo = await getUserInfoByUserId(this.loggedInUserId);
                        this.id = userInfo.orgId;
                    }
                    const orgInfo = await getOrgInfoById(this.id);
                    this.title = orgInfo.name;
                    this.userList = await getUserCoachList(orgInfo.id);

                    const orgList = await getOrgList();

                    await Promise.all(
                        this.userList.map(async (item) => {
                            const programNumber = await getProgramNumberByUserId(item.uid);
                            item.programNumber = programNumber;
                            const orgResult = orgList.find(elm => elm.id == item.orgId);
                            item.orgName = orgResult.name;
                        })
                    );
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToProgramList(item){
            this.$router.push(`/program/program-list/coach/${item.uid}`);
        }
    },
};
</script>
